import React from 'react';
import { Alert } from 'react-bootstrap';

export default function UkiesNoEdits({ componentSettings, setComponentSettings, onChange, selectedComponent, setSelectedComponent }) {
    return (
        <div>
            {/* Help Information */}
            <Alert variant="info" className="small" style={{ backgroundColor: '#e6ebea90', border: 'none', color: 'var(--ukies-dark-green)'}}>
                <Alert.Heading className="h6">Wat betekent "Niet aanpasbaar"?</Alert.Heading>
                <p className="mb-0">
                    Dit component is gemarkeerd als niet-aanpasbaar, wat betekent dat de inhoud niet via deze interface kan worden bewerkt. Dit wordt meestal gebruikt voor:<br/>
                    <br />
                    • Complexe HTML-structuren die handmatig zijn opgebouwd<br/>
                    • Componenten die externe scripts of speciale configuratie vereisen<br/>
                    • Content die alleen door ontwikkelaars moet worden aangepast<br/>
                    <br />
                    <strong>Let op:</strong> Je kunt dit component wel activeren/deactiveren en de positie wijzigen door het te verslepen.
                </p>
            </Alert>
        </div>
    );
}